import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// History Page
const HistoryPage = () => {
  return (
    <div data-testid="history-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/ragt7iz1_backyard.jpg"
        alt="Murphy's Giving Market History"
      />

      {/* History Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="history-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-8"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              History
            </h1>
            
            <p 
              data-testid="history-text"
              className="text-[#666666] text-base md:text-lg leading-relaxed"
            >
              Murphy's Giving Market began at the start of the COVID-19 pandemic when Desireé LaMarr-Murphy set up a free "market" in her backyard for neighbors who needed food. When the lines outside Desireé's house began to stretch around the block, MGM moved to its current location on West Chester Pike in Upper Darby. MGM partners with local foodbanks, businesses, schools, and nonprofits, working as a network to ensure that fresh, healthy, and culturally appropriate food reaches as many people in need as possible. MGM's community resource center brings together community organizations to provide access to educational, health, housing, and advocacy programs. Initially under fiscal sponsorship by the Federation of Neighborhood Centers, MGM began operations under its own 501c3 in fall 2023.
            </p>
            
            {/* Photo with credit */}
            <div className="mt-8">
              <a 
                href="https://www.inquirer.com/news/hunger-upper-darby-philadelphia-covid-19-philabundance-food-insecurity-20210211.html"
                className="block"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/pw7cij66_Desiree%20credit%20JOSE%20F%20MORENO%20%20Philadelphia%20Inquirer.jpg"
                  alt="Desireé LaMarr-Murphy at Murphy's Giving Market"
                  className="w-full rounded-lg hover:opacity-90 transition-opacity duration-300"
                />
              </a>
              <p className="text-sm text-[#666666] mt-2 italic">
                Photo: <a href="https://www.inquirer.com/news/hunger-upper-darby-philadelphia-covid-19-philabundance-food-insecurity-20210211.html" className="text-[#1877F2] hover:underline">Jose F. Moreno, Philadelphia Inquirer</a>
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HistoryPage;
